if (!customElements.get('color-swatch')) {
  class Colorswatch extends HTMLElement {
    constructor() {
      super();

      this.parentCard = this.closest('[data-product-card]');

      // Bind popup toggle events
      this.parentCard.querySelectorAll('[data-colorswatch-toggle]').forEach((button) =>
        button.addEventListener('click', this.onPopupToggle.bind(this))
      );

    }

    /**
     * Toggles the options popup
     * @description Renders the products based on the fetch url data.
     */
    onPopupToggle() {
      const popup = this.querySelector('[data-colorswatch-popup]');
      const popupIsOpenClass = 'colorswatch__popup--is-open';

      popup.classList.toggle(popupIsOpenClass);
    }
  }

  window.Colorswatch = Colorswatch;
  customElements.define('color-swatch', Colorswatch);
}
